import StakeService from '@/api/StakeService'
import WalletService from '@/api/WalletService'
import UtilService from '@/utils/UtilService'
const state = {
  balances: [],
  stakingBalances: [],
  walletHistory: []
}

const getters = {
  balances: state => state.balances,
  stakingBalances: state => state.stakingBalances,
  walletHistory: state => state.walletHistory
}

const mutations = {
  SET_BALANCES: (state, data) => {
    state.balances = data
  },
  SET_STAKING_BALANCES: (state, data) => {
    state.stakingBalances = data
  },
  SET_WALLET_HISTORY: (state, data) => {
    state.walletHistory = data
  }
}

const actions = {

  getWalletTransactionHistory ({ commit }, params) {
    return new Promise((resolve, reject) => {
      WalletService.getWalletTransactionHistory(params.page).then(res => {
        const paginationRes = res.pagination
        const result = UtilService.transformWalletTransactionHistory(res.data)
        if (result) {
          result.map((item) => {
            if (item.hash) {
              item.hashBeauty = item.hash.substring(0, 8) + '...' + item.hash.substring(item.hash.length - 5, item.hash.length)
            }
            if (item.currency === 'KAS') {
              item.scanUrl = 'kasScanUrl'
            } else if (item.currency === 'ETHW') {
              item.scanUrl = 'ethwScanUrl'
            } else {
              item.scanUrl = 'bscScanUrl'
            }
          })
          commit('SET_WALLET_HISTORY', result)
        }
        const pagination = {
          currentPage: paginationRes.page,
          totalPage: paginationRes.total_pages,
          totalRecord: paginationRes.total_records
        }
        this.dispatch('setWalletHistoryPagination', pagination)
        resolve(result)
      }).catch(e => {
        reject(e)
      })
    })
  },
  getBalances ({ commit }) {
    return new Promise((resolve, reject) => {
      WalletService.getBalances().then(res => {
        const result = UtilService.transformMainBalances(res.data)
        result && commit('SET_BALANCES', result)
        resolve(result)
      }).catch(e => {
        reject(e)
      })
    })
  },
  getStakingBalances ({ commit }) {
    return new Promise((resolve, reject) => {
      StakeService.getStakingBalance().then(res => {
        const result = UtilService.transformStakingBalances(res.data)
        result && commit('SET_STAKING_BALANCES', result)
        resolve(result)
      }).catch(e => {
        reject(e)
      })
    })
  },
  swap (__, data) {
    return new Promise((resolve) => {
      WalletService.swap(data).then(rs => {
        resolve(rs.status)
      })
    })
  },
  swapStaking (__, data) {
    return new Promise((resolve) => {
      WalletService.swapStaking(data).then(rs => {
        resolve(rs.status)
      })
    })
  },
  transfer (__, data) {
    return new Promise((resolve) => {
      WalletService.transfer(data).then(rs => {
        resolve(rs.status)
      })
    })
  },
  transferInternal (__, data) {
    return new Promise((resolve) => {
      WalletService.transferInternal(data).then(rs => {
        resolve(rs.status)
      })
    })
  },
  withdraw (__, data) {
    return new Promise((resolve) => {
      WalletService.withdraw(data).then(rs => {
        resolve(rs.status)
      })
    })
  },
  withdrawReceiveAmount (__, data) {
    return new Promise((resolve) => {
      WalletService.withdrawReceiveAmount(data).then(rs => {
        resolve(rs)
      })
    })
  }
}

export default { state, getters, mutations, actions }
